import React from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';


const SucessToast = (props) => {
 
    // toastr.remove();
    toastr.options.positionClass = props.position;
    toastr.success(props.text);

    return (
        <></>
    )
}

export default SucessToast;
